import styled, { css } from "styled-components"
import CloseIcon from "../close-icon"

export const Icon = styled(CloseIcon)`
  position: absolute;
  z-index: 1;
  right: 3px;
  top: 3px;
  border-radius: 100%;
  color: #fff;

  ${(props) => css`
    background-color: ${props.theme.colors.primary};
  `}
`

export const Image = styled.img`
  position: relative;
  width: 100%;
`

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
`
